<div class="card card-custom gutter-b card-stretch">
    <div class="card-body">
        <dx-report-designer [reportUrl]="reportName" height="80vh">
            <dxrd-callbacks> </dxrd-callbacks>
            <dxrd-request-options [getDesignerModelAction]="getDesignerModelAction" [host]="hostUrl"></dxrd-request-options>
        </dx-report-designer>
    </div>
</div>
